// material-ui
import { Box, useMediaQuery } from '@mui/material';

// project import
// import Message from './Message';
import Profile from './Profile';
import Notification from './Notification';
import FullScreen from './FullScreen';
import MobileSection from './MobileSection';

import useConfig from '@/from-theme/hooks/useConfig';
import DrawerHeader from '@/from-theme/layout/Dashboard/Drawer/DrawerHeader';

import { MenuOrientation } from 'config';
import Localization from './Localization';
import { useMemo } from 'react';

// ==============================|| HEADER - CONTENT ||============================== //

const HeaderContent = () => {
  const {i18n, menuOrientation } = useConfig();

  const downLG = useMediaQuery((theme) => theme.breakpoints.down('lg'));
  const localization = useMemo(() => <Localization />, [i18n]);

  return (
    <>
      {menuOrientation === MenuOrientation.HORIZONTAL && !downLG && <DrawerHeader open={true} />}
      {/* preserve spacing where Search was */}
      <Box sx={{ flexGrow: 1 }} />
      {!downLG && localization}
      {downLG && <Box sx={{ width: '100%', ml: 1 }} />}

      <Notification />
      {/* <Message /> */}
      {!downLG && <FullScreen />}
      {!downLG && <Profile />}
      {downLG && <MobileSection />}
    </>
  );
};

export default HeaderContent;
